export const EVENT_SET_FIELD_VALUE = "gcrud.set.field-value";
export const EVENT_SET_QUICK_SEARCH_VALUE = "gcrud.set.quick-search-value";

export const publishEvent = (eventName, payload = {}) => {
  window.dispatchEvent(
    new CustomEvent(eventName, {
      detail: payload,
    })
  );
};

export const subscribeEvent = (eventName, callback) => {
  window.addEventListener(eventName, callback);
};

export const unsubscribeEvent = (eventName, callback) => {
  window.removeEventListener(eventName, callback);
};
